import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";

const INITIAL_VISIBLE_COUNT = 6;

const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);
  // czy pokazujemy wszystkie pozycje, czy tylko pierwsze 6
  const [showAll, setShowAll] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    ADV: "Filmy Reklamowe",
    EVENT: "Filmy Eventowe",
    REAL_ESTATE: "Nieruchomości",
    SM: "Social Media",
    PHOTOS: "Sesje zdjęciowe",
  };

  const types = {
    IMAGE: "image",
    VIDEO: "video",
    DOCUMENT: "document",
  };

  const projectsData = [
    {
      title: "Przedstawienie nieruchomości - film promocyjny",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "l-ENU9ww_aE",
      },
      thumbImage: "images/projects/project-11.jpg",

      categories: [filters.REAL_ESTATE],
    },

    {
      title: "Gama Basket - ogłoszenie sponsora",
      type: types.VIDEO,
      video: {
        vimeo: true,
        id: "1213948736",
        orientation: "vertical",
      },
      thumbImage: "images/projects/project-13.jpg",

      categories: [filters.SM, filters.ADV],
    },
    {
      title: "Mazda MX5 - film sprzedażowy",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "wJBWP1-QyCI",
        orientation: "vertical",
      },
      thumbImage: "images/projects/mazda2.jpg",

      categories: [filters.ADV],
    },
    {
      title: "Mecz Kociewskie Diabły",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "gF8QAxGkIOY",
      },
      thumbImage: "images/projects/SKS.jpg",

      categories: [filters.EVENT],
    },
       {
      title: "Przedstawienie nieruchomości - rolka promocyjna",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "l9r0bJE8etk",
        orientation: "vertical",
      },
      thumbImage: "images/projects/project-12.jpg",

      categories: [filters.SM,filters.REAL_ESTATE],
    },

    {
      title: "Makijaż Trend",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "3JZgEzkUK7U",
        orientation: "vertical",
      },
      thumbImage: "images/projects/project-3.jpg",

      categories: [filters.SM],
    },
        {
      title: "The Dynamite Spring 2026 - Drift Event Toruń",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "YySHfx4qVQo",
      },
      thumbImage: "images/projects/DNMT.jpg",

      categories: [filters.EVENT],
    },
     {
      title: "Festyn - Zakończenie sezonu SKS",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "yEcLgv68ANU",
      },
      thumbImage: "images/projects/SKS2.jpg",

      categories: [filters.EVENT],
    },
    {
      title: "Makijaż + Fryzura",
      type: types.VIDEO,
      video: {
        vimeo: true,
        id: "1209534501#t=0",
        orientation: "vertical",
      },

      thumbImage: "images/projects/projekt-7.jpg",
      categories: [filters.ADV],
    },
    {
      title: "Domki Letniskowe OlszeVita - film pokazowy",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "mM1CwHaludU",
      },

      thumbImage: "images/projects/Olszethumb.jpg",
      categories: [filters.REAL_ESTATE],
    },
    {
      title: "Sesja zdjęciowa domków letniskowych",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Każdy domek ma dwie sypialnie, salon z kuchnią oraz taras z widokiem na las. Dzieci pokochają plac zabaw, a dorośli docenią spokój, ciszę i zachody słońca przy lampce wina. OlszeVita to miejsce, gdzie tworzą się niezapomniane wspomnienia.",
        client: "OlszeVita",
        date: "02.07.2026",
        url: {
          name: "Dysk Google - pełna wersja sesji",
          link: "https://drive.google.com/drive/folders/1HwLywrJxbZYWkop6X87DRStdQg5VxR43?usp=drive_link",
        },

        sliderImages: [
          "images/projects/Olsze-2.jpg",
          "images/projects/Olsze-3.jpg",
          "images/projects/Olsze-4.jpg",
        ],
      },

      thumbImage: "images/projects/Olsze.jpg",

      categories: [filters.REAL_ESTATE],
    },
    {
      title: "Sesja sprzedażowa Mazda MX5",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Mazda MX-5 NC to trzecia generacja kultowego roadstera japońskiej marki. To model, który łączył zgrabną sylwetkę, trwałą mechanikę i fantastyczne wrażenia z jazdy. Ten egzemplarz z opcjonalnym, składanym, sztywnym dachem ma obecnie tylko 19 tys. km przebiegu. Stan zachowania jest wyśmienity.",
        client: "Osoba prywatna",
        date: "28.04.2026",
        url: {
          name: "Dysk Google - pełna wersja sesji",
          link: "https://drive.google.com/drive/folders/1eUFcBSq60bqZonLN7f_0zrnDrmLFNkZW?usp=sharing",
        },

        sliderImages: [
          "images/projects/mazda2.jpg",
          "images/projects/mazda3.jpg",
        ],
      },

      thumbImage: "images/projects/mazda1.jpg",

      categories: [filters.PHOTOS],
    },
        {
      title: "Drift Training Satori - Motopark Toruń",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "cZpyTTfR6pE",
      },
      thumbImage: "images/projects/project-10.jpg",

      categories: [filters.EVENT],
    },
     {
      title: "Mercedes-Benz W201 190E",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "8B7cSBwNLBY",
      },
      thumbImage: "images/projects/project-9.jpg",

      categories: [filters.SM],
    },
    
  ];

  // Renderujemy zawsze WSZYSTKIE pozycje w DOM - "Rozwiń/Zwiń" steruje ich
  // widocznością przez natywny mechanizm filtrowania Isotope (ta sama, płynna
  // animacja przenikania/skalowania, co przy przełączaniu kategorii filtra).
  const canExpand = filterKey === "*" && projectsData.length > INITIAL_VISIBLE_COUNT;

  // wspólna funkcja filtrująca: łączy aktualnie wybraną kategorię z limitem 6 pozycji
  const getIsotopeFilter = () => (itemElem) => {
    const matchesCategory =
      filterKey === "*" || itemElem.classList.contains(filterKey);

    if (!matchesCategory) return false;

    const isExtraItem = itemElem.classList.contains("extra-item");
    if (filterKey === "*" && !showAll && isExtraItem) return false;

    return true;
  };

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key / rozwiń-zwiń change
  useEffect(() => {
    if (imagesLoaded && isotope.current) {
      isotope.current.arrange({ filter: getIsotopeFilter() });
    }
  }, [filterKey, showAll, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => {
    setFilterKey(key);
    // przy zmianie filtra wracamy do widoku zwiniętego dla zakładki "Wszystkie"
    setShowAll(false);
  };

  const getVisibilityClass = (index) =>
    index >= INITIAL_VISIBLE_COUNT ? "extra-item" : "";

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Moje realizacje
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                Wszystkie
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " + (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories) +
                      " " +
                      getVisibilityClass(index)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(project);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="fas fa-file-alt"></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fas fa-image"></i>
                              )}
                              {project.type === types.VIDEO && (
                                <i className="fas fa-video"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Makosky Media</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          {/* Przycisk Rozwiń / Zwiń - tylko na zakładce "Wszystkie", gdy jest więcej niż 6 pozycji */}
          {canExpand && (
            <div className="text-center mt-5 wow fadeInUp">
              <button
                type="button"
                className="btn btn-color-primary rounded-0"
                onClick={() => setShowAll((prev) => !prev)}
              >
                {showAll ? (
                  <>
                    Zwiń <i className="fas fa-chevron-up ms-2" aria-hidden="true" />
                  </>
                ) : (
                  <>
                    Rozwiń <i className="fas fa-chevron-down ms-2" aria-hidden="true" />
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;